/* global refreshCommitmentDataUrl storeUrl ordersListUrl procurementsDashboardUrl */
/* global getProcurementMilestonesUrl updateProcurementMilestonesUrl minDate maxDate integrationConfigured vikEnabled */
/* global supplierRequestStoreUrl supplierRequestSuggestionsUrl supplierRequestRecipients syncSuppliersEnabled draftSaveUrl draftData groupSupplierId */
/* global existingSupplierRequest uncommittedExpenditureGroupId supplierRequestWithdrawUrl */

import { React, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import PurchaseOrdersCreateForm from './PurchaseOrdersCreateForm';

import { idempotencyHeader } from 'Helpers/apiUtils';

export default function PurchaseOrdersCreate(props) {
    const [mutationHeader, setMutationHeader] = useState(idempotencyHeader());

    return (
        <PurchaseOrdersCreateForm
            refreshCommitmentDataUrl={refreshCommitmentDataUrl}
            storeUrl={storeUrl}
            ordersListUrl={ordersListUrl}
            procurementsDashboardUrl={procurementsDashboardUrl}
            mutationHeader={mutationHeader}
            getExpenseMilestonesUrl={getProcurementMilestonesUrl}
            updateExpenseMilestonesUrl={updateProcurementMilestonesUrl}
            minDate={minDate}
            maxDate={maxDate}
            integrationConfigured={integrationConfigured}
            syncSuppliersEnabled={typeof syncSuppliersEnabled !== 'undefined' ? syncSuppliersEnabled : 0}
            vikEnabled={vikEnabled}
            supplierRequestStoreUrl={typeof supplierRequestStoreUrl !== 'undefined' ? supplierRequestStoreUrl : ''}
            supplierRequestSuggestionsUrl={typeof supplierRequestSuggestionsUrl !== 'undefined' ? supplierRequestSuggestionsUrl : ''}
            supplierRequestRecipients={typeof supplierRequestRecipients !== 'undefined' ? supplierRequestRecipients : []}
            draftSaveUrl={typeof draftSaveUrl !== 'undefined' ? draftSaveUrl : ''}
            draftData={typeof draftData !== 'undefined' ? draftData : null}
            groupSupplierId={typeof groupSupplierId !== 'undefined' ? groupSupplierId : null}
            existingSupplierRequest={typeof existingSupplierRequest !== 'undefined' ? existingSupplierRequest : null}
            supplierRequestWithdrawUrl={typeof supplierRequestWithdrawUrl !== 'undefined' ? supplierRequestWithdrawUrl : ''}
            resumeGroupId={typeof uncommittedExpenditureGroupId !== 'undefined' ? uncommittedExpenditureGroupId : null}
        />
    );
}

if (document.getElementById('purchaseOrdersCreate')) {
    var root = document.getElementById('purchaseOrdersCreate');
    ReactDOM.render(
        <App>
            <PurchaseOrdersCreate />
        </App>,
        root,
    );
}
